"use strict";

(function () {
  'use strict';

  angular.module('directive.email-match', []).directive('compareTo', emailMatch);
  emailMatch.$inject = [];
  /* @ngInject */

  function emailMatch() {
    return {
      require: 'ngModel',
      scope: {
        otherModelValue: '=compareTo'
      },
      link: function link(scope, element, attributes, ngModel) {
        ngModel.$validators.compareTo = function (modelValue) {
          return modelValue === scope.otherModelValue;
        };

        scope.$watch('otherModelValue', function () {
          ngModel.$validate();
        });
      }
    };
  }
})();